export default "__VITE_ASSET__bo73knTb__"